<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="clientStatus" slot-scope="scope">
        <el-tag :class="'client-status-class-' + scope.row.clientStatus">{{
          getClientStatusName(scope.row.clientStatus)
        }}</el-tag>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permission.carparkspace_delete"
          plain
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/led/parkledtemplate';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { passageSelections } from '@/api/v4ward/park/passage/parkpassage';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      reWrite: false,
      selectionList: [],
      tempParkingLotId: '',
      operateType: '',
      option: {
        tip: false,
        tree: true,
        searchShow: true,
        searchMenuSpan: 6,
        height: 'auto',
        //calcHeight: 30,
        border: true,
        index: true,
        labelWidth: 120,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            //dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            editDisabled: true,
            search: true,
            searchSpan: 5,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属通道',
            prop: 'passageName',
            editDisplay: false,
            addDisplay: false,
          },

          {
            label: '所属通道',
            prop: 'passageId',
            type: 'tree',
            hide: true,
            search: false,
            viewDisplay: false,
            dicData: [],
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择设备所属通道',
                trigger: 'change',
              },
            ],
            /*change: ({ value, column }) => {
              if (this.operateType == '') {
                return;
              }
              if (this.vdui.isEmpty(this.form.parkingLotId) && this.vdui.isNotEmpty(value)) {
                this.$message.warning('请先选择停车场');
              }

            },*/
          },

          /*{
            label: '通道类型',
            prop: 'inOut',
            type: 'select',
            dicData: [
              { label: '入场播报显示', value: 1 },
              { label: '出场播报显示', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择出入类型',
                trigger: 'change',
              },
            ],
          },*/
          {
            label: '语音类型',
            prop: 'voiceNo',
            type: 'select',
            dicData: [
              { label: '入场语音', value: 1 },
              { label: '出场语音', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择语音类型',
                trigger: 'change',
              },
            ],
          },

          {
            label: '语音名称',
            prop: 'voiceName',
            searchSpan: 4,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入语音名称',
                trigger: 'change',
              },
            ],
          },

          {
            label: '语音内容',
            prop: 'voiceContent',
            searchSpan: 4,
            hide: true,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入语音内容',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'LED内容',
            //LED屏显示内容
            prop: 'screenContent',
            maxlength: 20,
            searchSpan: 4,
            rules: [
              {
                required: true,
                message: '请输入LED屏显示内容',
                trigger: 'change',
              },
            ],
          },
          {
            label: '显示时间',
            //屏幕内容显示时间，单位：秒
            prop: 'showTime',
            searchSpan: 4,
            rules: [
              {
                required: true,
                message: '请输入屏幕内容显示时间单位秒',
                trigger: 'change',
              },
              { pattern: /^[1-9][+]?\d{0,8}$/, message: '请输入9位以内数字' },
            ],
          },
          {
            label: '第一行',
            //LED屏显示内容第一行
            prop: 'screenContentLine1',
            searchSpan: 4,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入LED屏显示内容第一行',
                trigger: 'change',
              },
            ],
          },
          {
            label: '第二行',
            prop: 'screenContentLine2',
            maxlength: 20,
            /*dicData: [
              { label: '月卡车', value: 1 },
              { label: '临停车', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },*/
            rules: [
              {
                required: true,
                message: '请输入LED屏显示内容第二行',
                trigger: 'change',
              },
            ],
          },

          {
            label: '第三行',
            //LED屏显示内容第三行
            prop: 'screenContentLine3',
            maxlength: 20,
            searchSpan: 4,
            rules: [
              {
                required: false,
                message: '请输入LED屏显示内容第三行',
                trigger: 'change',
              },
            ],
          },
          {
            label: '第四行',
            //LED屏显示内容第四行
            prop: 'screenContentLine4',
            searchSpan: 4,
            maxlength: 20,
            rules: [
              {
                required: false,
                message: '请输入LED屏显示内容第四行',
                trigger: 'change',
              },
            ],
          },

          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: false,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
          /*{
            label: '版本',
            prop: 'version',

            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },*/
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkledtemplate_add, false),
        viewBtn: this.vaildData(this.permission.parkledtemplate_view, false),
        delBtn: this.vaildData(this.permission.parkledtemplate_delete, false),
        editBtn: this.vaildData(this.permission.parkledtemplate_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.parkingLotId'() {
      this.form.passageId = '';
      let parkingLotIdTem = this.form.parkingLotId;
      if (this.vdui.isNotEmpty(parkingLotIdTem)) {
        this.loadPassageSelections(this.form.parkingLotId);
      }
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    loadPassageSelections(parkId) {
      if (typeof parkId === 'undefined') {
        return;
      }
      passageSelections({ parkId: parkId }).then((res) => {
        if (this.operateType === 'add') {
          this.form.passageId = null;
        }
        const column = this.findObject(this.option.column, 'passageId');
        column.dicData = res.data;
      });
      /* const passageIdColumn = this.findObject(this.option.column, 'passageId');
      this.form.passageId = '';
      if (this.vdui.isNotEmpty(parkId)) {
        monthChargeRuleList(Object.assign({ spaceId: parkId })).then(({ data }) => {
          passageIdColumn.dicData = data;
        });
      } else {
        passageIdColumn.dicData = [];
      }*/
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      if (['add'].includes(type)) {
        const column = this.findObject(this.option.column, 'passageId');
        column.dicData = [];
      }
      done();


    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        this.query.parkingLotId = this.tempParkingLotId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
